import { render, staticRenderFns } from "./AddEditAssignment.vue?vue&type=template&id=5ffbbf68&"
import script from "./AddEditAssignment.vue?vue&type=script&lang=js&"
export * from "./AddEditAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports